import React from "react";
import './_static/TableHeader.css';

function TableHeader(props) {

    const [sortColumn, setSortColumn] = React.useState(null)
    const [sortDirectionAscending, setSortDirectionAscending] = React.useState(false)

    function sort(event) {
        if (props.filterUpdate !== undefined) {
            const selected = event.target.getAttribute('header')
            props.filterUpdate({target: {name: 'ordering', value: selected}})
            if (sortColumn === selected) {
                setSortDirectionAscending(!sortDirectionAscending)
            }
            else {
                setSortDirectionAscending(false)
            }
            setSortColumn(selected)
        }
    }

    function getHeader(header) {
        let headerText = header.caption ? header.caption : header.label
        if (sortColumn === header.label) {
            headerText += ' ' + (sortDirectionAscending ? '▼' : '▲')
        }
        return headerText
    }

    return (
        <thead className="table-dark table-header">
            <tr>
                {
                    props.headers.map((header, index) => (
                        <th className={`col_headers ${header.narrow ? 'narrow' : ''}`}
                            onClick={sort} key={index}
                            header={header.label}>
                            {getHeader(header)}
                        </th>
                    ))
                }
                {
                    props.actions ?
                        <th className="col_headers"></th>
                        : null
                }
            </tr>
        </thead>
    )
}

export default TableHeader
